import React, {Fragment} from 'react';

class Icon{
    constructor(viewBox, svg){
        this.viewBox = viewBox
        this.svg = <Fragment>{[...svg]}</Fragment>
    }
}

const svgs = {
    "facebook": new Icon("0 0 64 64", 
        [<path d="M47.4,25.8L47.4,25.8h-5.6h-2v-2v-6.2v-2h2H46c1.1,0,2-0.8,2-2V3c0-1.1-0.8-2-2-2h-7.3c-7.9,0-13.4,5.6-13.4,13.9v8.7v2h-2
	h-6.8c-1.4,0-2.7,1.1-2.7,2.7v7.2c0,1.4,1.1,2.7,2.7,2.7h6.6h2v2v20.1c0,1.4,1.1,2.7,2.7,2.7h9.4c0.6,0,1.1-0.3,1.5-0.7
	s0.7-1.1,0.7-1.7l0,0l0,0V40.3v-2h2.1H46c1.3,0,2.3-0.8,2.5-2v-0.1v-0.1l1.4-6.9c0.1-0.7,0-1.5-0.6-2.3
	C49.1,26.4,48.2,25.9,47.4,25.8z"/>]),

    "instagram": new Icon ("0 0 64 64", [<path d="M32,17.6c-7.9,0-14.4,6.4-14.4,14.4c0,7.9,6.4,14.4,14.4,14.4c7.9,0,14.3-6.4,14.3-14.4C46.3,24.1,39.9,17.6,32,17.6z
    M32,41.9c-5.4,0-9.9-4.4-9.9-9.9c0-5.4,4.4-9.9,9.9-9.9c5.4,0,9.8,4.4,9.8,9.9C41.8,37.4,37.4,41.9,32,41.9z"/>, <path d="M47,11.6c-2,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5C50.5,13.2,49,11.6,47,11.6z"/>, <path d="M46.9,1.8H17.1C8.6,1.8,1.8,8.6,1.8,17.1V47c0,8.4,6.9,15.3,15.3,15.3H47c8.4,0,15.3-6.9,15.3-15.3V17.1
    C62.3,8.6,55.4,1.8,46.9,1.8z M57.8,46.9c0,6-4.8,10.8-10.8,10.8H17.1c-6,0-10.8-4.8-10.8-10.8V17.1c0-6,4.9-10.8,10.8-10.8h29.8
    c6,0,10.8,4.9,10.8,10.8V46.9z"/>]),

    "twitter": new Icon("0 0 64 64", [<path d="M56.1,15.3l3.8-4.8c1.1-1.3,1.4-2.3,1.5-2.8c-3,1.8-5.8,2.4-7.6,2.4h-0.7l-0.4-0.4c-2.4-2.1-5.4-3.2-8.6-3.2
	c-7,0-12.5,5.8-12.5,12.5c0,0.4,0,1,0.1,1.4l0.3,2l-2.1-0.1C17.1,21.9,6.6,10.9,4.9,9C2.1,14,3.7,18.8,5.4,21.8l3.4,5.6l-5.4-3
	c0.1,4.2,1.7,7.5,4.8,9.9l2.7,2l-2.7,1.1c1.7,5.1,5.5,7.2,8.3,8l3.7,1l-3.5,2.4C11.1,52.8,4.1,52.5,1,52.2c6.3,4.4,13.8,5.4,19,5.4
	c3.9,0,6.8-0.4,7.5-0.7c28-6.6,29.3-31.6,29.3-36.6v-0.7l0.6-0.4c3.4-3.2,4.8-4.9,5.6-5.9c-0.3,0.1-0.7,0.3-1.1,0.4L56.1,15.3z"/>]),

    "default": null
}

export default svgs;